"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetService = void 0;
const Leaf = __importStar(require("leaf-ts"));
const app_consensus_1 = require("@branch-ts/app-consensus");
const debug_consensus_1 = require("@branch-ts/debug-consensus");
const puri_1 = require("@branch-ts/puri");
const practice_auth3_web_1 = require("@branch-ts/practice-auth3-web");
const practice_term_web_1 = require("@branch-ts/practice-term-web");
const web_1 = require("@branch-ts/web");
const web_consensus_1 = require("@branch-ts/web-consensus");
const service_VersetSingular_1 = require("./service.VersetSingular");
const biome_ai_web_1 = require("@branch-ts/biome-ai-web");
const feature_1 = require("./service.Verset/feature");
const versetFacilityMechanism_1 = require("./versetFacilityMechanism");
const service_VersetProbe_1 = require("./service.VersetProbe");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_VersetVerse_1 = require("./service.VersetVerse");
const service_VersetIC_1 = require("./service.VersetIC");
const service_VersetBusinessGuide_1 = require("./service.VersetBusinessGuide");
let VersetService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)({
            ambient: false,
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetService = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        constructor(config) {
            this.config = config;
            this.debug = debug_consensus_1.Debug.instance(this).tag(this.constructor.name, "app").enable();
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                NavigationService: web_1.NavigationService,
                VersetProbeService: service_VersetProbe_1.VersetProbeService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                VersetVerseService: service_VersetVerse_1.VersetVerseService,
                VersetICService: service_VersetIC_1.VersetICService,
                VersetBusinessGuideService: service_VersetBusinessGuide_1.VersetBusinessGuideService,
                VersetSingularService: service_VersetSingular_1.VersetSingularService,
                SessionService: practice_auth3_web_1.SessionService,
            });
            this.situations = new Leaf.Situations({
                ready: false
            });
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        clearTerminalFeatures() {
            this.terminalBindings?.destroy();
            this.terminalSound?.destroy();
            this.terminalActivities?.destroy();
        }
        async initialize() {
            this.config.browserFeature.start();
            await this.setup();
            this.unregisterLogout = web_consensus_1.LogoutMechanism.registerAction("Verset.browser", () => {
                this.config.browserFeature.dispose();
                this.clearTerminalFeatures();
                this.agreement = undefined;
            }, { phase: "cleanup" });
        }
        destroy() {
            this.unregisterLogout?.();
            this.clearTerminalFeatures();
            this.config.browserFeature.dispose();
        }
        async setup() {
            await this.deps.SessionService.situations.wait("authorized", true);
            const agreementData = this.deps.VersetRequireLoginService.agreement;
            const vendor = agreementData.vendor;
            const editorKind = agreementData.particulars.versetWebapp.verse.editorKind;
            puri_1.PURI.setProcessVendor(vendor);
            puri_1.PURI.setLegacyVendorKindMap({
                cps: vendor,
                local: vendor,
            });
            puri_1.PURI.setHttpPuriHandler(window.location.protocol + "//" + window.location.host + "/puri");
            (0, feature_1.BrowserExternalURIFeature)();
            (0, feature_1.AppContentNavigationFeature)({
                navigation: this.deps.NavigationService,
            });
            const terminalDomains = this.deps.VersetProbeService.terminalDomains;
            this.terminalActivities = new biome_ai_web_1.TerminalDomainActivities(terminalDomains);
            (0, practice_term_web_1.FatTerm)({
                bell: true,
            });
            const intelligenceCenter = this.deps.VersetICService.main;
            if (!intelligenceCenter) {
                throw new Error("Verset editor biome requires its Intelligence Center");
            }
            (0, feature_1.AppEditorBiomeFeature)({
                intelligenceCenter,
                vendor,
                editorKinds: [
                    editorKind,
                    agreementData.particulars.versetWebapp.idps.editorKind,
                ],
                storage: this.deps.VersetRequireLoginService.unlimitedStorageProvider,
                terminalDomains,
                terminalActivities: this.terminalActivities,
                onMissingTerminal: () => this.deps.VersetBusinessGuideService.handleMissingTerminal(() => terminalDomains.getDomains({ online: true }).length > 0),
                onMissingFileSystem: () => this.deps.VersetBusinessGuideService.handleMissingFileSystem(),
            });
            const mainVerse = this.deps.VersetVerseService.main;
            if (mainVerse) {
                this.terminalBindings = (0, biome_ai_web_1.FatVerseTerminalBindings)({
                    verse: mainVerse,
                    activities: this.terminalActivities,
                });
            }
            this.terminalSound = (0, biome_ai_web_1.FatTerminalCompletionSound)({ activities: this.terminalActivities });
            this.agreement = agreementData;
            versetFacilityMechanism_1.VersetFacilityMechanism.install({
                app: this.me.app,
                server: this.server,
                agreement: agreementData,
                services: this.me.app.services,
            });
            await this.deps.VersetSingularService.welcome();
            this.situations.set("ready", true);
            const compileTimeInfo = window["CompileTimeInfo"];
            if (compileTimeInfo) {
                console.error("VersetIsReady", {
                    compiledAt: new Date(compileTimeInfo.compiledAt).toLocaleString(),
                    compiledPath: compileTimeInfo.webpack,
                });
            }
        }
    };
    return VersetService = _classThis;
})();
exports.VersetService = VersetService;
